import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const InputWithSubTextWidget = ({
  id,
  onChange,
  placeholder,
  required,
  value,
  options
}: WidgetProps) => {
  return (
    <div>
      <Mtds.Input
        type='text'
        id={id}
        onChange={({ target }) => onChange(target.value)}
        placeholder={placeholder}
        required={required}
        value={value ?? ''}
      />
      {typeof options?.undertext === 'string' ||
      typeof options?.undertext === 'number' ? (
        <div style={{ marginTop: 4, color: '#888', fontSize: 12 }}>
          {options?.undertext}
        </div>
      ) : null}
    </div>
  )
}
